module.exports = __webpack_public_path__ + "media/images/icons/flags/GW-3b1fff5952f78ca3186adc64f71756c1.svg";